module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_maedori_02@3x-a27dd3ea2f026e0529268593d5d229c7.webp";